var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 495 495",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc653",
    d: "M89.803,366.872V257.069c-30.272,0-54.901,24.629-54.901,54.902S59.53,366.872,89.803,366.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc653",
    d: "M89.803,385.041C40.285,385.041,0,425.327,0,474.844v20h179.605v-20 C179.605,425.327,139.32,385.041,89.803,385.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.197,366.872V257.069c-30.272,0-54.901,24.629-54.901,54.902S374.925,366.872,405.197,366.872z",
    fill: "#ffc653"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc653",
    d: "M405.197,385.041c-49.518,0-89.803,40.286-89.803,89.803v20H495v-20 C495,425.327,454.715,385.041,405.197,385.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc653",
    d: "M247.5,109.959V0.156c-30.272,0-54.901,24.629-54.901,54.902S217.228,109.959,247.5,109.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffab00",
    d: "M144.704,311.971c0-30.273-24.629-54.902-54.901-54.902v109.803 C120.075,366.872,144.704,342.243,144.704,311.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffab00",
    d: "M460.099,311.971c0-30.273-24.629-54.902-54.901-54.902v109.803 C435.47,366.872,460.099,342.243,460.099,311.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffab00",
    d: "M302.401,55.057c0-30.273-24.629-54.902-54.901-54.902v109.803 C277.772,109.959,302.401,85.33,302.401,55.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc653",
    d: "M337.303,217.931c0-49.518-40.285-89.803-89.803-89.803s-89.803,40.286-89.803,89.803v20h179.605 V217.931z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffab00",
    points: "267.5,333.052 267.5,267.816 227.5,267.816 227.5,333.052 171.004,365.67 191.004,400.311  247.5,367.693 303.996,400.311 323.996,365.67  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternProjectIcon);
export default __webpack_public_path__ + "static/media/intern-project-icon.8efa4ccdabfb7daf28fc5f4f5007011c.svg";
export { ForwardRef as ReactComponent };